import { useState } from "react";
import {
  Home,
  User,
  Settings,
  Menu,
  X,
  LogOut,
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: <Home size={20} /> },
    { name: "Campaigns", path: "/campaigns", icon: <Settings size={20} /> },
    { name: "Contacts", path: "/contacts", icon: <Settings size={20} /> },
    { name: "Deals", path: "/deals", icon: <Settings size={20} /> },
    { name: "Tasks", path: "/tasks", icon: <Settings size={20} /> },
    { name: "Reports", path: "/reports", icon: <Settings size={20} /> },
    { name: "Profile", path: "/profile", icon: <User size={20} /> },
    { name: "Settings", path: "/settings", icon: <Settings size={20} /> },
  ];

  return (
    <div className="flex">
      {/* Sidebar */}
      <div
        className={`h-screen bg-white text-gray-900 transition-all duration-300 
        ${isOpen ? "w-64" : "w-20"} flex flex-col`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4">
          {isOpen && <img src="/images/logo.png" className='m-auto mb-7' alt="logo" width={200} height={200}/>}
          <button onClick={() => setIsOpen(!isOpen)} className="close-btn">
            {isOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {/* Menu Items */}
        <div className="p-4 space-y-2">
        {menuItems.map((item) => (
          <Link
            key={item.name}
            to={item.path}
            className={`flex items-center gap-3 p-3 rounded-lg transition-all
              ${
                location.pathname === item.path
                  ? "bg-black text-white"
                  : "hover:bg-black hover:text-white"
              }`}
          >
            {item.icon}
            {isOpen && <span>{item.name}</span>}
          </Link>
        ))}
      </div>

        {/* Logout */}
        <div className="p-4 border-t border-gray-700">
          <div className="flex items-center gap-3 p-3 rounded-lg cursor-pointer hover:text-red-600 transition-all">
            <LogOut size={20} />
            {isOpen && <span>Logout</span>}
          </div>
        </div>
      </div>
    </div>
  );
}
